module.exports = __webpack_public_path__ + "img/2-en.de34d130.jpg";